import React from 'react';
import ReactDOM from 'react-dom';
import Consultant from '../components/Consultant';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

document.addEventListener('DOMContentLoaded', () => {
  const $consultantContainers = document.querySelectorAll('[data-consultant]');

  $consultantContainers.forEach($consultantContainer => {
    ReactDOM.render(<Consultant />, $consultantContainer);
  });

  const $upsellAddToCartButtons = document.querySelectorAll('.cart__upsells [data-variant-id]');
  $upsellAddToCartButtons.forEach($button =>
    $button.addEventListener('click', async event => {
      const {handle, variantId} = event.currentTarget.dataset;
      const upsellDetails = window.theme.cartUpsells.products.find(({upsellProduct, conditionalProduct}) => {
        const productMatch = upsellProduct === handle;
        const conditionalMatch = conditionalProduct
          ? window.theme.cart.items.some(item => item.handle === conditionalProduct)
          : true;
        return productMatch && conditionalMatch;
      });
      const response = await fetch(`/products/${handle}.js`);
      const productJson = await response.json();
      const selectedVariant =
        productJson.variants.find(v => v.id === parseInt(variantId, 10)) || productJson.variants[0];
      const item = {
        id: variantId,
        quantity: 1,
        properties: {
          _upsell: handle,
          _original_price: selectedVariant.price,
        },
      };
      if (upsellDetails && upsellDetails.conditionalDiscount) {
        item.properties._upsell_conditional_id = upsellDetails.conditionalProductId;
        item.properties._upsell_conditional_discount = upsellDetails.conditionalDiscount;
        item.properties._upsell_conditional_hash = upsellDetails.conditionalHash;
      }
      const items = [item];
      window.sideCart.handleAddToCartEvent(items, false, 0, '', () => window.location.reload());
    })
  );

  const $removeAutoUpsellButtons = document.querySelectorAll('[data-remove-auto-upsell]');
  $removeAutoUpsellButtons.forEach($button =>
    $button.addEventListener('click', () => {
      window.localStorage.setItem('removedAutoUpsell', Date.now() + 1000 * 60 * 60 * 24);
    })
  );

  /**
   * Initialise upsells slider
   */
  const $upsellsContainer = document.querySelector('.cart__upsells');
  if ($upsellsContainer) {
    const $upsellsSlider = $upsellsContainer.querySelector('.cart__upsells .cart-upsells__items');
    if ($upsellsSlider && $upsellsSlider.scrollWidth > $upsellsSlider.clientWidth) {
      $upsellsContainer.style.width = '100%';

      const $previousButton = $upsellsContainer.querySelector('[data-cart-upsells-button-prev]');
      const $nextButton = $upsellsContainer.querySelector('[data-cart-upsells-button-next]');

      const slider = new Flickity($upsellsSlider, {
        prevNextButtons: false,
        pageDots: true,
        imagesLoaded: true,
        groupCells: true,
        cellAlign: 'left',
        on: {
          ready() {
            $previousButton.disabled = this.selectedIndex === 0;
            $nextButton.disabled = this.selectedIndex === this.slides.length - 1;
            $previousButton.addEventListener('click', () => {
              slider.previous();
            });
            $nextButton.addEventListener('click', () => {
              slider.next();
            });
          },
          change() {
            $previousButton.disabled = this.selectedIndex === 0;
            $nextButton.disabled = this.selectedIndex === this.slides.length - 1;
          },
        },
      });
    }
  }

  const buttonAddtoCartPage = document.querySelector('.js-button-add-to-cart')
  const { productCondition } = window.newCartUpsellConfig
  const isHasNewUpsell = globalCartItems?.items?.some(item => item.product_id === productCondition.id)

  buttonAddtoCartPage && buttonAddtoCartPage.addEventListener('click', (e) => {
    if (isHasNewUpsell) {
      e.preventDefault()

      document.dispatchEvent(new CustomEvent('open-modal-upsell'))
    }
  })

  const allTriggerRemoveItem = document.querySelectorAll('.js-trigger-remove-item')
  if (allTriggerRemoveItem.length > 0) {
    allTriggerRemoveItem.forEach((item, index) => {
      const itemProductId = item.getAttribute('data-product-id')
      const quantityLast = parseInt(item.getAttribute('data-quantity'))
      const productUpsell = globalCartItems?.items.find(item => item.properties?._new_upsell)
      if (itemProductId.toString() === productCondition?.id.toString() && productUpsell?.id && quantityLast === 1) {
        const currentLineItem = globalCartItems?.items.find(line => line.product_id.toString() === itemProductId.toString())

        item.addEventListener('click', (e) => {
          e.preventDefault()
    
          window.location.href = `${Shopify.routes.root}cart/update?updates[${currentLineItem.key}]=0&updates[${productUpsell.key}]=0`
        })
      }

    })
  }
});
